import { TemplateRef } from '@angular/core';
import { Observable } from 'rxjs';
import { IAnyObject } from '../../services/error/error.handler';

export enum OirDialogSize {
  DEFAULT,
  SMALL,
  LARGE,
  XLARGE
}

export enum OirDialogButton {
  ACCEPT = 'COMMON.ACCEPT',
  APPROVE = 'COMMON.APPROVE',
  CANCEL = 'COMMON.CANCEL',
  CLOSE = 'COMMON.CLOSE',
  CONFIRM = 'COMMON.CONFIRM',
  CONTINUE = 'COMMON.CONTINUE',
  DECLINE = 'COMMON.DECLINE',
  DISCARD = 'COMMON.DISCARD',
  NO = 'COMMON.NO',
  OK = 'COMMON.OK',
  YES = 'COMMON.YES'
}

export const DIALOG_POSITION = {
  TOP_RIGHT: {
    top: '0',
    right: '0'
  },
  TOP_LEFT: {
    top: '0',
    left: '0'
  },
  BOTTOM_RIGHT: {
    bottom: '0',
    right: '0'
  },
  BOTTOM_LEFT: {
    bottom: '0',
    left: '0'
  },
  TOP_CENTER: {
    top: '0'
  },
  BOTTOM_CENTER: {
    bottom: '0'
  },
  CENTER: {}
};

export interface IDialogPosition {
  top?: string;
  bottom?: string;
  left?: string;
  right?: string;
}

export interface IOirDialogOptions {
  title: string;
  message?: string;
  messageParams?: IAnyObject;
  template?: TemplateRef<any>;
  context?: any;
  scrollable?: boolean;
  translate?: boolean;
  disableClose?: boolean;
  hasBackdrop?: boolean;
  position?: IDialogPosition;
  size?: OirDialogSize;
  confirmButton?: OirDialogButton | string;
  cancelButton?: OirDialogButton | string;
  onConfirm?: () => Observable<any>;
  onCancel?: () => Observable<any>;
}
